import { css } from 'linaria';
import { cssTheme } from '@uds/theme-utils';


const root = css`
  overflow: hidden;
  overflow-wrap: break-word;
  &[data-alignment='CENTER'] {
    text-align: center;
  }
`;
const title = css`
  &[data-alignment='CENTER'] {
    justify-content: center;
  }
`;

const titleText = css`
  vertical-align: middle;
`;
          
const tick = css`
  display: inline-block;
  vertical-align: text-top;
  padding-left: ${cssTheme.gu1};
  width: ${cssTheme.gu3};
`;

export default () => {
  return {
    root,
    title,
    titleText,
    tick,
  };
};
